import { render, staticRenderFns } from "./Multimedia.vue?vue&type=template&id=4d2c281d&"
import script from "./Multimedia.vue?vue&type=script&lang=js&"
export * from "./Multimedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports